"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIcon = function LoadingIcon(props) {
  var className = props.className,
      icon = props.icon,
      spin = props.spin;

  var rootClass = (0, _classnames2.default)("erg-components-LoadingIcon", "fa", "fa-" + icon, className, { "fa-spin": spin });
  return _react2.default.createElement("i", { className: rootClass });
};

LoadingIcon.displayName = "LoadingIcon";

LoadingIcon.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  spin: _propTypes2.default.bool
};

LoadingIcon.defaultProps = {
  icon: "circle-o-notch",
  spin: true
};

exports.default = LoadingIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/LoadingIcon.js
 ** module id = 259
 ** module chunks = 0
 **/